import { Localized } from '../../internal/Localized';
import Styles from './About.module.css';
import { Label } from '@app/engine';

/**
 * Terms tab — two bubble panels side by side: Terms of Service and SMS Notice. Reuses the existing localized strings from the Login terms popups.
 *
 * @returns The terms tab element.
 */
export function TermsTab() {
  return (
    <section>
      <Label text={Localized.AboutTermsLabel} classNameContainer={Styles.sectionLabel} />
      <Label text={Localized.AboutTermsTitle} classNameContainer={Styles.sectionTitle} />

      <div className={Styles.bubblePanelRow}>
        <div className={Styles.bubblePanel}>
          <div className={Styles.bubblePanelTitle}>{Localized.AboutTermsToSPanelTitle}</div>
          <div className={Styles.bubblePanelText}>
            <Label text={Localized.AuthTermsIntro} classNameContainer={Styles.bubblePanelTextParagraph} />
            <Label text={Localized.AuthTermsPrivacyTitle} classNameContainer={Styles.bubblePanelSubHeader} />
            <Label text={Localized.AuthTermsPrivacyBody} classNameContainer={Styles.bubblePanelTextParagraph} />
          </div>
        </div>

        <div className={Styles.bubblePanel}>
          <div className={Styles.bubblePanelTitle}>{Localized.AboutTermsSMSPanelTitle}</div>
          <div className={Styles.bubblePanelText}>
            <Label text={Localized.AuthSmsNoticeIntro} classNameContainer={Styles.bubblePanelTextParagraph} />
            <Label text={Localized.AuthTermsSmsTitle} classNameContainer={Styles.bubblePanelSubHeader} />
            <Label text={Localized.AuthTermsSmsBody} classNameContainer={Styles.bubblePanelTextParagraph} />
            <Label text={Localized.AuthTermsSmsOptOut} classNameContainer={Styles.bubblePanelTextParagraph} />
            <Label text={Localized.AuthTermsCallersTitle} classNameContainer={Styles.bubblePanelSubHeader} />
            <Label text={Localized.AuthTermsCallersBody} classNameContainer={Styles.bubblePanelTextParagraph} />
          </div>
        </div>
      </div>
    </section>
  );
}
